export default "__VITE_ASSET__DD2T2__E__"